/**
 * Pending intent for template variable_effects after insert.
 * Apply only after confirmed successful send with matching fingerprint (edited → no apply).
 */

export type MessarioTemplateEffectsPending = {
  template_id: number,
  peer_id: string,
  fingerprint: string
};

let pending: MessarioTemplateEffectsPending | null = null;

/**
 * Must match AiTemplateVariableEffectsService::normalizeSentText / Panel messenger helper.
 */
export function normalizeMessarioTemplateEffectsText(text: unknown): string {
  let value = String(text ?? '').trim();
  value = value.replace(/\u2014|\u2013/g, '-');
  value = value.replace(/\r\n|\r/g, '\n');
  return value;
}

export function messarioTemplateEffectsFingerprintsMatch(a: unknown, b: unknown): boolean {
  return normalizeMessarioTemplateEffectsText(a) === normalizeMessarioTemplateEffectsText(b);
}

export function getMessarioTemplateEffectsPending(): MessarioTemplateEffectsPending | null {
  return pending;
}

export function setMessarioTemplateEffectsPending(entry: MessarioTemplateEffectsPending | null) {
  pending = entry;
}

export function clearMessarioTemplateEffectsPending() {
  pending = null;
}

/**
 * Record intent after a successful template insert (rendered text already in composer).
 * Replaces any previous intent (other template / peer).
 */
export function noteMessarioTemplateEffectsInsert(args: {
  templateId: number,
  peerId: string | number,
  renderedText: string
}) {
  const peer = String(args.peerId ?? '').trim();
  const templateId = Number(args.templateId);
  if(!peer || !(templateId > 0)) {
    clearMessarioTemplateEffectsPending();
    return;
  }

  setMessarioTemplateEffectsPending({
    template_id: templateId,
    peer_id: peer,
    fingerprint: normalizeMessarioTemplateEffectsText(args.renderedText)
  });
}

/** Test helper. */
export function resetMessarioTemplateEffectsPendingForTests() {
  pending = null;
}
